import { Component } from "@angular/core";
import { PurchaseHistoryService } from "../purchaseHistory/purchaseHistory.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormControl } from "@angular/forms";
import { Constants } from "../constants/constants"
import { FormStatus } from "../enums/enums";
import { ActivatedRoute } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import { PurchaseFormService } from "../purchaseForm/purchaseForm.service";

@Component({
    selector: "managerApproval",
    templateUrl: "/app/managerApproval/managerApproval.template.html",
    providers: [PurchaseHistoryService, PurchaseFormService]
})

export class ManagerApprovalComponent {
    managerApprovals = [] as Array<IPurchaseHistoryModel>;
    managerHistory = [] as Array<IPurchaseHistoryModel>;
    filter = new FormControl();
    search = "";
    lastSortedColumnApproval = "id";
    lastSortedColumnHistory = "id";
    isDescApproval = true;
    isDescHistory = true;
    managerApprovalsRowCount = 0;
    managerApprovalsPageSize = 20;
    managerApprovalsPageNumber = 1;
    managerHistoryRowCount = 0;
    managerHistoryPageSize = 20;
    managerHistoryPageNumber = 1;
    restUrl = Constants.attachtmentsUrl;
    glCodeList = [] as Array<IGLCodeModel>;
    selectedGLCode: IGLCodeModel = null;
    loadingPendingApprovals: boolean = true;
    loadingCompletedApprovals: boolean = true;
    invalidGlCode: boolean = false;
    attachmentname: string = "";
    constructor(private purchaseHistoryService: PurchaseHistoryService, private purchaseFormService: PurchaseFormService,  private toast: ToastsManager, private constants: Constants, private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

        this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
            if (term) {
                this.searchManagerApprovals(term, 1);
                this.searchManagerHistory(term, 1);
            } else {
                this.getManagerApprovals();
                this.getManagerApprovalHistory();
            }
        });

    }
    getManagerApprovals(): void {
        this.managerApprovals = [];
        if (this.search && this.search.length > 0)
            this.searchManagerApprovals(this.search, this.managerApprovalsPageNumber);
        else {
            this.purchaseHistoryService.getManagerApprovals(this.constants.user.email, this.managerApprovalsPageNumber, this.managerApprovalsPageSize).subscribe((managerApprovals: { approvals: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
                if (managerApprovals) {
                    this.managerApprovals = managerApprovals.approvals;
                    this.managerApprovalsRowCount = managerApprovals.rowCount;
                }
                this.loadingPendingApprovals = false;
            });
        }
    }

    getManagerApprovalHistory(): void {
        this.loadingCompletedApprovals = true;
        this.managerHistory = [];
        if (this.search && this.search.length > 0)
            this.searchManagerHistory(this.search, this.managerHistoryPageNumber);
        else {
            this.purchaseHistoryService.getManagerApprovalHistory(this.constants.user.email, this.managerHistoryPageNumber, this.managerHistoryPageSize).subscribe((managerHistory: { history: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
                if (managerHistory) {
                    this.managerHistory = managerHistory.history;
                    this.managerHistoryRowCount = managerHistory.rowCount;
                }
                this.loadingCompletedApprovals = false;
            });
        }
    }

    showHideDetails(purchaseHistory: IPurchaseHistoryModel, showDetails: boolean=false): void {
        if (purchaseHistory.isVisible === undefined)
            purchaseHistory.isVisible = false;

        if (showDetails)
            purchaseHistory.isVisible = true;
        else
            purchaseHistory.isVisible = !purchaseHistory.isVisible;
        this.invalidGlCode = false;
        if (purchaseHistory.managerComment == 'null')
            purchaseHistory.managerComment = '';
    }

    lookUpForGlCode(query: string) {
        if (query.length > 3) {
            this.purchaseFormService.getGLCodeList(query.replace(/-/g,'')).subscribe((response: Array<IGLCodeModel>): void => {
                this.glCodeList = [];
                this.glCodeList = response;
                this.glCodeList.forEach(item => { item.glAcctCode = this.purchaseFormService.formatGLCode(item.glAcctCode, [8, 2, 3, 2], '-'); });
            });
        }
    }

    onGlCodeChange(glCode: any, index: number) {
        glCode = glCode.replace(/-/g, "");
        if (glCode.length > 0)
            this.managerApprovals[index].glCode = this.purchaseFormService.formatGLCode(glCode, [8, 2, 3, 2], '-');
    }

    approvePurchase(purchaseHistory: IPurchaseHistoryModel): void {
        if (!purchaseHistory.glCode) {
            this.showHideDetails(purchaseHistory, true);
            return;
        }
        if (purchaseHistory.glCode) {
            this.purchaseFormService.isGlCodeExist(purchaseHistory.glCode.replace(/-/g,'')).subscribe((response: boolean): void => {
                if (response) {
                    this.loadingPendingApprovals = true;
                    this.invalidGlCode = false;
                    if (!purchaseHistory.submitting) 
                        this.updateManagerComment(purchaseHistory, true);
                } else {
                    this.showHideDetails(purchaseHistory, true);
                    this.invalidGlCode = true;
                }
            });
        }
    }

    denyPurchase(purchaseHistory: IPurchaseHistoryModel): void {
        this.loadingPendingApprovals = true;
        if (!purchaseHistory.submitting) {
            this.updateManagerComment(purchaseHistory, false);
        }

    }

    updateManagerComment(approval: IPurchaseHistoryModel, approving: boolean): void {
        if(approving && !approval.glCode)
        {
            this.showHideDetails(approval);
            return;
        }
        this.loadingPendingApprovals = true;
        approval.managerComment = approval.managerComment === '' ? null : approval.managerComment;
        this.purchaseHistoryService.updateManagerComment(approval.id, approval.managerComment, approval.glCode).subscribe((result: boolean): void => {
            if (result) { }
            if (approving) {
                if (!approval.submitting) {
                    approval.submitting = true;
                    this.updateApprovalStatus(approval, FormStatus.Approved, this.constants.user.username);
                }
            } else {
                if (!approval.submitting) {
                    approval.submitting = true;
                    this.updateApprovalStatus(approval, FormStatus.Denied, this.constants.user.username);
                }
            }
        });
    }

    updateApprovalStatus(approval: IPurchaseHistoryModel, toFormStatusId: number, username: string): void {
        this.purchaseHistoryService.updateApprovalStatus(approval.id, toFormStatusId, username).subscribe((result: boolean): void => {
            if (result) {
                var index = this.managerApprovals.indexOf(approval);

                if (index > -1)
                    this.managerApprovals.splice(index, 1);

                this.getManagerApprovalHistory();

                this.toast.success(`Purchase ${approval.id} has been updated.`, "Success", { toastLife: 5000 });
            } else
                this.toast.error("Error processing you request.", "Error", { toastLife: 10000 });
            this.loadingPendingApprovals = false;
        });
    }

    showApprovalArrows(column: string): boolean {
        return this.isDescApproval && this.lastSortedColumnApproval === column;
    }

    setSortOrderApproval(columnName: string) {
        if (this.lastSortedColumnApproval === columnName)
            this.isDescApproval = !this.isDescApproval;
        else
            this.isDescApproval = true;

        this.lastSortedColumnApproval = columnName;
    }

    showHistoryArrows(column: string): boolean {
        return this.isDescHistory && this.lastSortedColumnHistory === column;
    }

    setSortOrderHistory(columnName: string) {
        if (this.lastSortedColumnHistory === columnName)
            this.isDescHistory = !this.isDescHistory;
        else
            this.isDescHistory = true;

        this.lastSortedColumnHistory = columnName;
    }

    searchManagerApprovals(term: string, pageNumber: number): void {
        if (term) {
            this.purchaseHistoryService.getManagerApprovalsSearch(this.constants.user.email, pageNumber, this.managerApprovalsPageSize, term).subscribe((managerApprovals: { approvals: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
                if (managerApprovals) {
                    this.managerApprovalsPageNumber = pageNumber;
                    this.managerApprovals = managerApprovals.approvals;
                    this.managerApprovalsRowCount = managerApprovals.rowCount;
                    this.loadingPendingApprovals = false;
                }
            });
        }
    }

    searchManagerHistory(term: string, pageNumber: number): void {
        if (term) {
            this.purchaseHistoryService.getManagerApprovalHistorySearch(this.constants.user.email, pageNumber, this.managerHistoryPageSize, term).subscribe((managerHistory: { history: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
                if (managerHistory) {
                    this.managerHistoryPageNumber = pageNumber;
                    this.managerHistory = managerHistory.history;
                    this.managerHistoryRowCount = managerHistory.rowCount;
                    this.loadingCompletedApprovals = false;
                }
            });
        }
    }
    downloadAttachment(formTypeId: number, formId: number, fileName: string) {
        this.purchaseHistoryService.downloadAttachment(formTypeId, formId, fileName).subscribe((blob) => {
            const fileURL = (window.URL || window.webkitURL).createObjectURL(blob);

            // Open in new browser tab
            const tab = window.open(fileURL, '_blank');

            if (!tab) {
                alert('Please allow popups for this site to preview files.');
            }

            // Cleanup memory later
            setTimeout(() => {
                try {
                    (window.URL || window.webkitURL).revokeObjectURL(fileURL);
                } catch (e) { }
            }, 10000);
        }, err => {
            console.error(err);
            alert('Error opening file');
        }
        );
    }
}